import React from 'react';

const ManagementLayout = () => {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <div className="text-center p-8">
        <h2 className="text-3xl font-bold text-gray-800 dark:text-white mb-4">
          Bientôt disponible
        </h2>
        <p className="text-gray-600 dark:text-white">
          Cette fonctionnalité est en cours de développement et sera disponible prochainement.
        </p>
      </div>
    </div>
  );
};

export default ManagementLayout;